import { iconsWithLinks } from "constants/architectsTranslation";

function IconsLinksSection({ icon, link, text }: iconsWithLinks) {
  return (
    <a
      href={link}
      target="_blank"
      className="text-decoration-none d-flex align-items-center mb-3"
    >
      <i className={`fe-${icon} mr-2`}></i>
      {text}
    </a>
  );
}

export default IconsLinksSection;
